import "./dayjs.min.js"

/*
    Named CalenderPicker to be different from the date picker used in Pickers
*/

let now = dayjs().toDate();

const daysOfWeek = Array.from(
    { length: 7 },
    (n, i) => (n = dayjs().day(i).format("dd"))
);

const getPreSpacerDays = () => {
    const firstDayOfMonth = dayjs(now).startOf('month').format('dd')
    const spacerIdx = daysOfWeek.findIndex((item) => item === firstDayOfMonth);

    return spacerIdx
}

const getPostSpacerDays = () => {
    const lastDayOfMonth = dayjs(now).endOf('month').format('dd');
    const spacerIdx = daysOfWeek.findIndex((item) => item === lastDayOfMonth);
    const numberOfDaysInWeekZeroIndexed = 6;

    return numberOfDaysInWeekZeroIndexed - spacerIdx;
}

const createMonth = () => {
    // Create one array of the empty days from Sun to month start, the month days, then the empty spacer days from month end to Sat
    const pre = new Array(getPreSpacerDays()).fill('');
    const post = new Array(getPostSpacerDays()).fill('');
    const days = Array.from(
        { length: dayjs(now).daysInMonth() },
        (n, i) =>
        (n = dayjs(now)
            .date(i + 1)
            .toDate())
    );

    return [...pre, ...days, ...post];
}

let daysOfMonth = createMonth();
const buildHeader = () => `<thead><tr>${daysOfWeek.map((day) => `<th>${day}</th>`).join('')}</tr></thead>`;
const buildTable = () => `<tbody><tr>${daysOfMonth.map((date, index) => {
    const daysStr = `<td class="${date ? 'isDay' : ''}"><button data-time="${date ? dayjs(date).format('DD/MM/YYYY') : ''}">${date ? dayjs(date).format("DD") : ''}</button></td>`;
    const trTag = (index !== 0 && index % 7 === 0) ? `</tr><tr>` : ''

    return `${trTag}${daysStr}`;
}).join('')}</tbody>`;

const buildCalendar = (css) => `<div class="m-calendar-picker hide js-form-ignore-validation" style="${css}">
        <div class="m-calendar-picker__header">
            <button class="m-calendar-picker__prevMonth inactive">
                <i class="m-calendar-picker__prevMonth__icon fa-solid fa-circle-arrow-left"></i>
            </button>
            <div class="m-calendar-picker__title">${dayjs(now).format("MMMM YYYY")}</div>
            <button class="m-calendar-picker__nextMonth">
                <span class="m-calendar-picker__nextMonth__icon fa-solid fa-circle-arrow-right"></i>
            </button>
        </div>
        <table class="m-calendar-picker__table">
            ${buildHeader()}
            ${buildTable()}
        </table>    
    `;

const handleListeners = (input) => {
    const c = input.nextSibling;
    c.querySelector('.m-calendar-picker__prevMonth').addEventListener('click', (e) => {
        changeMonth(c, 'prev')
        e.preventDefault()
    });
    c.querySelector('.m-calendar-picker__nextMonth').addEventListener('click', (e) => {
        changeMonth(c, 'next')
        e.preventDefault()
    });
    c.querySelector('.m-calendar-picker__table').addEventListener('click', (e) => {
        if (e.target.getAttribute('data-time')) {
            input.value = e.target.getAttribute('data-time')
            closeCalendar();
        }

        e.preventDefault()
    })

    input.addEventListener('click', () => showCalendar(c))
}

const outsideClickHandler = (e) => {
    if (!e.target.closest('.m-calendar-picker')) {
        closeCalendar();
    }
}

const showCalendar = (cal) => {
    requestAnimationFrame(() => window.site.doc.on('click', outsideClickHandler))
    cal.classList.remove('hide');
}
const closeCalendar = () => {
    requestAnimationFrame(() => window.site.doc.off('click', outsideClickHandler));
    [...document.querySelectorAll('.m-calendar-picker')].forEach(cal => cal.classList.add('hide'));
}

const init = (inputField) => {
    inputField[0].insertAdjacentHTML('afterend', buildCalendar())
    handleListeners(inputField[0])
}

const changeMonth = (calendar, delta) => {
    const prevButton = calendar.querySelector('.m-calendar-picker__prevMonth')
    if (delta === 'prev') {
        now = dayjs(now).subtract(1, 'month')

        if (dayjs(now).isBefore(dayjs())) {
            prevButton.classList.add('inactive')
        }
    }

    if (delta === 'next') {
        now = dayjs(now).add(1, 'month')
        prevButton.classList.remove('inactive')
    }

    daysOfMonth = createMonth();
    calendar.querySelector('.m-calendar-picker__title').innerHTML = dayjs(now).format("MMMM YYYY");
    calendar.querySelector('.m-calendar-picker__table').innerHTML = ` 
        ${buildHeader()}
        ${buildTable()}
    `;
}

export default init;
